import styled from '@emotion/styled';
import { Typography } from '@mui/material';
import { Box } from '@mui/system';
import { OutlineButton } from 'shared-components/Buttons/Outline';

export const Wrapper = styled(Box)(({ theme }) => ({
  maxWidth : '968px',
  margin   : '0 auto',
}));

export const PageTitle = styled(Typography)(({ theme }) => ({
  fontSize   : '32px',
  fontWeight : '700',
  fontFamily : 'Montserrat',
  color      : theme.palette.primary.greenPKD,
}));

export const AccentTitle = styled(Typography)(
  ({ theme, textAlign = 'left' }) => ({
    fontWeight : '400',
    fontFamily : 'Montserrat',
    fontSize   : '14px',
    lineHeight : '24px',
    textAlign,
  })
);

export const PrintButtonWrapper = styled(OutlineButton)(({ theme }) => ({
  borderRadius : '6px',
  position     : 'absolute',
  top          : '146px',
  right        : '84px',
}));

export const PKDLink = styled('a')(({ theme }) => ({
  color : theme.palette.primary.blue1,
}));
